import store from '../configureStore';

import {
  plugin,
  config,
  zone,
  education
} from '../redux/actions';
import { setHelpItems } from '../pages/HelpScreens/redux/actions';
import sortHelpExtraConfig from './sortHelpExtraConfig';
import { setBPItems } from '../pages/BulkPickup/redux/actions';
import { setProjectId } from '../redux/actions/plugin';

const { dispatch } = store.store;

const { setStoreDistricts } = plugin;

const {
  setDistrictId,
  setLocalityId,
  setReminderOption,
} = config;

const {
  setPrompts,
  setCoordinate,
  setMapCityName,
  setExampleAddress,
  setGoogleSearchTerm,
} = zone;

const { setEducationData } = education;

const detectHelpItemRoute = ({
  type, custom_message: customMsg, title, extra_config
}, oidx) => {
  if (customMsg) return ({ path: '/help/description-page', params: { customMsg } });

  switch (type.toLowerCase()) {
    case 'missed_pickup':
      return {
        path: '/help/confirm-location',
        params: { prevRoute: '/help', extra_config }
      };

    case 'damaged_cart':
      return {
        path: extra_config ? '/help/damaged-cart' : '/help/form-page',
        params: extra_config ? { extra_config, oidx } : { title, type }
      };

    case 'reminder_problem':
      return { path: '/help/contact-us', params: { title, type, extra_config } };

    case 'other':
      return { path: '/help/other-problems', params: { extra_config } };

    default:
      return { path: '/help/form-page', params: { title, type, extra_config } };
  }
};

const checkItemShouldDisplay = (type, problems, hasCalendar) => {
  switch (type.toLowerCase()) {
    case 'other':
      return problems.filter(({ display_opt }) => display_opt !== 'P').length > 0;

    default:
      return true;
  }
};

const setDistrictsArray = (districts, selectedDistrict, hasCalendar, project_id = '') => {
  dispatch(setStoreDistricts(districts));
  let selectedDistrictData = districts[selectedDistrict];
  if (project_id) {
    const districtValuesArray = Object.values(districts);
    selectedDistrictData = districtValuesArray
      .find((i) => i.district_id === selectedDistrict
        && i.project_id.toUpperCase() === project_id.toUpperCase());
  }

  if (selectedDistrict && selectedDistrict !== '-') {
    dispatch(setEducationData(selectedDistrictData.education_tab_elements));
    dispatch(setPrompts(selectedDistrictData.prompts));
    dispatch(setDistrictId(selectedDistrictData.district_id));
    dispatch(setMapCityName(selectedDistrictData.map_city_nm));
    dispatch(setLocalityId(selectedDistrictData.cms_locality_id));
    dispatch(setExampleAddress(selectedDistrictData.example_address));
    dispatch(setReminderOption(selectedDistrictData.reminder_option));
    dispatch(setProjectId(selectedDistrictData.project_id));

    if (
      selectedDistrictData.map_city_nm
      && selectedDistrictData.map_city_nm.google_search_term
    ) {
      dispatch(setGoogleSearchTerm(
        selectedDistrictData.map_city_nm.google_search_term
      ));
    }

    /**
     * Set the right format of lat & long coordinates
     */
    let lat = null;
    let lng = null;
    const { geo_point } = selectedDistrictData;
    if (geo_point) {
      const format = /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;

      if (geo_point.match(format)) {
        let changedCoordinate = geo_point.replace(/[&/\\#+()$~%'":*?<>{}]/g, '');
        changedCoordinate = changedCoordinate.split(',');
        [lat, lng] = changedCoordinate;
      }
    }
    dispatch(setCoordinate({ lat: Number(lat), lng: Number(lng) }));

    /**
     * Set the right format of help items
     */
    dispatch(
      setHelpItems(
        [...selectedDistrictData.help_items]
          .map((({ oidx, ...rest }) => {
            const isOther = rest.type.toLowerCase() === 'other';
            return ({
              route: detectHelpItemRoute(rest, oidx),
              oidx: (isOther)
                ? selectedDistrictData.help_items.length + 5
                : oidx,
              shouldDisplay: checkItemShouldDisplay(
                rest.type,
                // Maybe we can remove this in future?!
                selectedDistrictData.problem_types,
                hasCalendar
              ),
              ...rest,
              ...(rest.type === 'DAMAGED_CART') && ({ extra_config: sortHelpExtraConfig(rest?.extra_config) }),
            });
          }))
          .sort((a, b) => a.oidx - b.oidx)
      )
    );
    if ([...selectedDistrictData.help_items].find((item) => item.type === 'PICKUP_REQUEST')) {
      dispatch(setBPItems([...selectedDistrictData.help_items].find((item) => item.type === 'PICKUP_REQUEST')));
    }

    return selectedDistrictData.district_id;
  }

  return undefined;
};

export default setDistrictsArray;
